import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material"
import { green, grey } from "@mui/material/colors"
import React, { useMemo } from "react"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { formatPrice } from "../../../helppers/formatters"

export default function AcceptedView({ item }) {
  const action = useMemo(() => {
    return JSON.parse(item?.action)
  }, [item?.action])
  return (
    <ListItem key={item?._id} alignItems="flex-start">
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: green[500] }}>
          <CheckCircleIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`${item?.createdBy} / ${item?.delaership?.dname}`}
        secondary={
          <React.Fragment>{`— ${action?.txt} - ${formatPrice(
            action?.amount
          )}`}</React.Fragment>
        }
      />
    </ListItem>
  )
}
